import React from 'react';
import Title from './Title';
import NextButton from './NextButton';

const IntroClue: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p>
        Welcome to your 2026 Valentine's Scavenger Hunt! I know we're going to
        be in Hawaii for the actual day, and we can still have a fun night out
        together there, but I wanted to make sure to do something here to
        properly celebrate you! So today you'll have to collect a series of
        clues and gifts to find me for our date tonight...
      </p>
      <p>
        For your first stop head to the room next to the kids room and find your
        new candle:
      </p>
      <img style={{ alignSelf: 'center' }} src='candle.jpg' />
      <NextButton
        acceptedClues={['biuniu']}
        prompt='Enter the clue on the bottom of the candle:'
      />
    </div>
  );
};

export default IntroClue;
